import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  Box,
  Collapse,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TagSelector from "./SelectTag"; // SelectTagをインポート

/**
 * テンプレートリストのヘッダーコンポーネント
 * @param {Object} props - プロパティ
 * @param {Array} props.templates - 全テンプレートのリスト
 * @param {Function} props.onFilterChange - フィルタリング結果を親に通知するコールバック関数
 * @param {boolean} [props.tagSelectorEnabled=false] - タグセレクター機能が有効かどうか
 */
function TemplateListHeader({
  templates,
  onFilterChange,
  tagSelectorEnabled = false,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showTagSelector, setShowTagSelector] = useState(false);
  const [filteredByTagTemplates, setFilteredByTagTemplates] =
    useState(templates); // タグフィルター結果を保持

  // 検索クエリまたはタグフィルター結果が変更されたときにフィルタリングを実行
  useEffect(() => {
    let filtered = tagSelectorEnabled ? filteredByTagTemplates : templates; // タグセレクター無効時はタグフィルターを無視

    // 次に検索クエリでフィルタリング
    if (searchQuery) {
      filtered = filtered.filter((template) =>
        template.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    onFilterChange(filtered); // 最終的なフィルタリング結果を親に通知
  }, [
    searchQuery,
    filteredByTagTemplates,
    templates,
    onFilterChange,
    tagSelectorEnabled,
  ]); // 依存配列に templates と tagSelectorEnabled を追加

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleTagSelector = () => {
    setShowTagSelector((prev) => !prev);
    // タグセレクターを閉じたときはタグフィルターをリセットする
    if (showTagSelector) {
      setFilteredByTagTemplates(templates);
    }
  };

  // TagSelectorからの変更を受け取るコールバック
  const handleTagFilterChange = (filteredTemplates) => {
    setFilteredByTagTemplates(filteredTemplates);
  };

  return (
    <Paper sx={{ width: "100%", mb: 2, p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
      >
        <Box sx={{ flexGrow: 1 }}>
          <TextField
            label="テンプレート名で検索"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            size="small"
            sx={{ flexGrow: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {tagSelectorEnabled && (
          <IconButton
            onClick={toggleTagSelector}
            aria-label="toggle tag selector"
            sx={{ alignSelf: { xs: "flex-end", sm: "center" } }}
          >
            {showTagSelector ? <FilterListOffIcon /> : <FilterListIcon />}
          </IconButton>
        )}
      </Box>
      {tagSelectorEnabled && (
        <Collapse in={showTagSelector}>
          <Box pt={2}>
            <TagSelector
              templates={templates}
              setTemplatesDisplay={handleTagFilterChange}
              style={{ fontSize: "24px" }}
            />
          </Box>
        </Collapse>
      )}
    </Paper>
  );
}

export default TemplateListHeader;
